import clsx from "clsx"
import { FC, memo } from "react"
import { Trans } from "react-i18next"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./UserSpeedBonus.module.scss"
import { IUserSpeedBonus } from "./types"

const UserSpeedBonusComponent: FC<IUserSpeedBonus> = ({ speedBonus }) => {
  return (
    <div className={clsx(styles.UserSpeedBonus)}>
      <Trans i18nKey="speedBonus" components={{ br: <br /> }} />:{" "}
      <OutlinedText className={clsx(styles.UserSpeedBonus_bonus)}>
        {speedBonus}
      </OutlinedText>
    </div>
  )
}

export const UserSpeedBonus = memo(UserSpeedBonusComponent)
